module.exports = __webpack_public_path__ + "852af3411a01da7cfdd8bcffa55b82f1.svg";